"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORE_SORTING_KIND = void 0;
exports.STORE_SORTING_KIND = {
    BY_SALES: 'BY_SALES',
    BY_DATE: 'BY_DATE'
};
//# sourceMappingURL=storeSortingKind.js.map